import unregisteredUsersSlice from './unregisteredUsers';


export default {
    unregisteredUsersSlice,
};
